import { Layer } from './layer';
import { composeLayer, WithMergeMode, WithWrapper } from './tf-properties';

export class Bidirectional extends composeLayer([WithMergeMode, WithWrapper]) {
    weights = null;
    backward_layer: Layer = null;
}

export class TimeDistributed extends composeLayer([WithWrapper]) {}
